import { render, staticRenderFns } from "./order-view-baseinfo.vue?vue&type=template&id=55c64185&scoped=true&"
import script from "./order-view-baseinfo.vue?vue&type=script&lang=js&"
export * from "./order-view-baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./order-view-baseinfo.vue?vue&type=style&index=0&id=55c64185&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c64185",
  null
  
)

export default component.exports